import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { sortProjectByCode } from '../../actions/expenseAccount/project';
import { sortActivityByCode } from '../../actions/expenseAccount/activity';
import { sortDepartmentByCode } from '../../actions/expenseAccount/department';
import { sortWorksiteByCode } from '../../actions/expenseAccount/worksite';
import { sortProvince } from '../../actions/expenseAccount/province';
import { paramDefault } from '../../actions/expenseAccount/paramDefault';
import { sortTaskByCode } from '../../actions/expenseAccount/task';
import { paramPayment } from '../../actions/timesheet/paramPayment';
import { sortExpenseAccountCodesByCode } from '../../actions/expenseAccount/expenseAccountCode';
import { sortPayUnitsByCode } from '../../actions/expenseAccount/payUnit';
import { sortCorporateCreditCardsByCode } from '../../actions/expenseAccount/corporateCreditCard';
import { sortWorkPlaceByCode } from '../../actions/expenseAccount/workPlace';
import { sortServiceProvider } from '../../actions/expenseAccount/serviceProvider';
import { addExpenseAccount, deleteExpenseAccount, addDocument, getExpenseAccount, getExpenseAccountDocument, deleteDocument, loadCombos } from '../../actions/expenseAccount';
import Button from 'react-bootstrap-button-loader';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { GetLanguage, IsEnglish } from '../../utils/language';
import { GetABCUsage } from '../../utils/companyConfig';
import { loadLocalization } from '../../utils/kendoLocalization';
import { formatDate, toDecimal, toDisplayDecimal } from '../../utils';
import { download } from '../../utils/download';
import * as storage from '../../utils/storage';
import moment from "moment";
import "moment/locale/fr";
import NumericTextField from '../controls/NumericTextField';
import OptionExpenseAccount from './OptionExpenseAccount';
import { Upload } from '@progress/kendo-react-upload';
import { IntlProvider, LocalizationProvider, registerForIntl, provideIntlService } from '@progress/kendo-react-intl';
import * as statusExpense from '../../scripts/StatusExpenseAccount';
import { format } from 'react-string-format';
import AlertAlgo from '../controls/AlertSnack'
import 'react-confirm-alert/src/react-confirm-alert.css';
import styles from '../../styles/expenseAccount.module.css';
import { Worksite } from '../../utils/users';
import { isIOS } from '../../utils';
import { Popup } from "@progress/kendo-react-popup";

loadLocalization();
moment.locale("fr");

const expenseTypeMR = 'REPASRECU';

const stylesMat = theme => ({
    appBar: {
        top: 'auto',
        bottom: '56px',
        height: '35px!important',
        boxShadow: '-2px 7px 20px 0px !important',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    appBarIOS: {
        bottom: '70px !important',
    },
    total: {
        minHeight: '35px',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    root: {
        paddingBottom: 'unset'
    },
    divDate: {
        marginBottom: '20px'
    },
    resetBtn: {
        width: '90px !important',
        margin: '0 10px !important'
    },
    deleteBtn: {
        margin: '0 10px !important'
    }
});

class CustomListItemUI extends React.Component {
    componentDidMount() {
    }

    render() {
        const { files } = this.props;

        const handleRemove = (id) => {
            var element = document.querySelector(`li[data-uid="${id}"]`);
            if (element !== undefined) {
                element.remove();
            }
        }

        const stopKendoKeys = (event) => {
            event.stopPropagation();
        };

        return (
            <div className={styles.rootFiles}>
                {
                    files.map(file =>
                        <div key={file.name}>
                            <div className="k-file-single">
                                <div className="k-file-extension-wrapper">
                                    <span className="k-file-extension">{file.extension}</span>
                                    <span className="k-file-state" />
                                </div>
                            </div>
                            <div className={styles.divFilename}>
                                <div className="k-file-name-size-wrapper">
                                    <span className="k-file-name" title="criteres-recherche-1.jpg">{file.name}</span>
                                    <span className="k-file-size">{parseFloat(file.size / 1024).toFixed(2)} KB</span>
                                </div>
                            </div>
                            <div className={styles.rootDivInfoFiles}>
                                <FormControl fullWidth className={styles.rootFilename}>
                                    <TextField
                                        id={"filename_" + file.uid}
                                        label={i18next.t('expenseAccount:files.filename')}
                                        defaultValue={file.name.replace(file.extension, '')}
                                        onKeyDown={stopKendoKeys}
                                    />
                                </FormControl>
                                <FormControl fullWidth className={styles.rootDescription}>
                                    <TextField
                                        id={"description_" + file.uid}
                                        label={i18next.t('expenseAccount:files.description')}
                                        onKeyDown={stopKendoKeys}
                                    />
                                </FormControl>
                            </div>
                            <div className={styles.deleteFile}>
                                <strong className="k-upload-status">
                                    <button type="button" onClick={() => handleRemove(file.uid)} tabIndex="-1" className="k-button k-button-icon k-flat k-upload-action">
                                        <span aria-label={i18next.t('expenseAccount:files.remove')} title={i18next.t('expenseAccount:files.remove')} className="k-icon k-delete k-i-x" />
                                    </button>
                                </strong>
                            </div>
                        </div>
                    )
                }
            </div>);
    }
}

class ExpenseAccountForm extends React.Component {
    intl;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errorForm: true,
            isActive: true,
            isComponentDidMountComplete: false,
            dataDetail: [],
            selectedDate: new Date(),
            local: "fr",
            expenseType: '',
            expenseTypeDescription: '',
            unitType: '',
            quantity: 1,
            unitRate: 0,
            total: 0,
            paymentType: -1,
            abcUsage: false,
            taskUsage: false,
            linkProjectPActivity: false,
            companyPayProject: false,
            companyPayActivity: false,
            openOption: false,
            listComplete: [],
            expenseAccountCodes: [],
            payUnits: [],
            disableUnitRate: false,
            corporateCreditCards: [],
            projects: [],
            project: '',
            projectPay: '',
            projectDefault: '',
            projectPDefault: '',
            activities: [],
            activity: '',
            activityPay: '',
            activityDefault: '',
            activityPDefault: '',
            department: '',
            departmentDefault: '',
            taskCode: '',
            taskCodeDefault: '',
            taskCodes: [],
            departments: [],
            worksite: Worksite() ?? '',
            disableWorksite: Worksite() ? true : false,
            worksiteDefault: Worksite() ?? '',
            worksites: [],
            provinces: [],
            province: '',
            comment: '',
            language: GetLanguage(),
            files: [],
            events: [],
            filePreviews: {},
            files_upload: [],
            remove_files_upload: [],
            files_edit: [],
            canModify: true,
            expenseAccountPunchId: 0,
            openConfirm: false,
            openConfirmDeleteFile: false,
            openConfirmReset: false,
            deleteFileId: '',
            anchorEl: null,
            downloadFile: null,
            isPostCompleted: true,
            isDeleteCompleted: true,
            isCreditCardSupport: storage.getCreditCardSupport(),
            isMandatoryUnitRate: false,
            maxQuantityUnit: 0,
            payUnitMax: null,
            payUnitDef: null,
            originalQuantityUnit: 0,
            originalPayUnit: null,
            hasPayUnitMax: false,
            isiOS: isIOS(),
            hasNonRefundableSubCode: false,
            isMandatoryLocation: false,
            useServiceProvider: storage.getUseServiceProvider(),
            serviceProviders: [],
            serviceProviderId: null,
            workPlaces: [],
            workPlaceId: null,
            isDisplayExpenseAccountClassif: storage.getIsDisplayExpenseAccountClassif(),
            isMandatoryFile: false,
            nonTaxableTip: false,
            tipAmount: 0
        };
        this.alert = React.createRef();

        this.intl = provideIntlService(this);
    }

    async componentDidMount() {

        const expenseId = this.props.expenseId !== undefined ? this.props.expenseId : 0;

        await this.loadParamPay();

        const language = GetLanguage();

        this.setState({ isActive: true, abcUsage: GetABCUsage(), linkProjectPActivity: storage.getLinkProjectPActivity(), expenseAccountPunchId: expenseId, locale: language }, async () => {
            if (this.state.expenseAccountPunchId > 0) {
                await this.loadEdit(this.state.expenseAccountPunchId);
                await this.loadDropDowns();
                const newState = this.getNewState();
                this.setState(newState, () => {
                    this.setState({ isComponentDidMountComplete: true });
                });
            }
            else {
                this.setState({ isComponentDidMountComplete: true });

                this.loadParamDefault().then(() => {
                    this.loadDropDowns().then(() => {
                        this.setState({ isActive: false });
                    });
                });
                // If we call like this, Service Worker crash the fetch sometimes
                //await this.loadParamDefault();
                //await this.loadDropDowns();
            }

            moment.locale(language);

            this.resizeForm(expenseId);
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.isComponentDidMountComplete) {
            if (prevState.isMandatoryLocation !== this.state.isMandatoryLocation
                && !this.state.isMandatoryLocation) {
                this.setState({ workPlaceId: null, serviceProviderId: null });
            } else if (this.state.isMandatoryLocation
                && this.state.workPlaceId > 0
                && this.state.serviceProviderId > 0
                && (this.state.unitRate !== 0 || !this.state.disableUnitRate)) {
                this.setState({ unitRate: 0, disableUnitRate: true });
            }
        }
    }

    loadParamPay = () => {
        return new Promise((resolve) => {
            paramPayment().then((result) => {
                const param = JSON.parse(result.param);

                this.setState({
                    companyPayProject: param.projectPay,
                    companyPayActivity: param.activityPay,
                    taskUsage: param.taskPay
                }, () => {
                    resolve();
                });
            });
        });
    }

    handleCloseEdit(message) {
        this.props.onCloseEdit(message);
    }

    loadEdit = async (id) => {
        return new Promise((resolve) => {
            getExpenseAccount(id).then((response) => {
                const obj = JSON.parse(response.expenseAccount);
                const mandatoryUnitRateValue = obj.expenseAccountCode == expenseTypeMR || obj.expenseAccountCode == "";

                this.setState({
                    selectedDate: new Date(obj.expenseDate),
                    expenseType: obj.expenseAccountCode,
                    unitType: obj.payUnit,
                    quantity: obj.quantity,
                    unitRate: obj.rate,
                    paymentType: obj.employeeCreditCardId == null ? 0 : obj.employeeCreditCardId,
                    project: obj.abcProjectCode,
                    projectPay: obj.projectCode,
                    activity: obj.activityCode,
                    activityPay: obj.activityPay,
                    department: obj.departmentCode,
                    worksite: obj.workSite,
                    province: obj.provinceCode,
                    comment: obj.description,
                    canModify: obj.approverId <= 0 && obj.loadPerformed == 'N',
                    total: obj.quantity * obj.rate,
                    isMandatoryComment: this.props.isMandatoryComment,
                    disableUnitRate: !mandatoryUnitRateValue,
                    hasNonRefundableSubCode: obj.refundable,
                    isMandatoryUnitRate: mandatoryUnitRateValue,
                    serviceProviderId: obj.expenseAccountServiceProviderId,
                    workPlaceId: obj.workplaceId,
                    taskCode: obj.taskCode
                }, async () => {
                    await this.loadDocument(this.state.expenseAccountPunchId);
                    resolve();
                })
            });
        });
    }

    loadDocument = async (id) => {
        return new Promise((resolve) => {
            getExpenseAccountDocument(id).then((response) => {
                const obj = JSON.parse(response.document);

                const files = [];

                obj.forEach(item => {
                    files.push(
                        {
                            documentId: item.documentId,
                            filename: item.fileName,
                            description: item.descriptionFile,
                            type: item.documentType,
                            base64: item.documentBase64
                        });
                });

                this.setState({ files_edit: files }, async () => {
                    resolve();
                });
            });
        });
    }

    loadDropDowns = async () => {
        return new Promise(async (resolve) => {
            var list = await loadCombos(formatDate(this.state.selectedDate), "%", this.state.department).catch(error => {
                console.log(error);
            });

            if (typeof list === 'undefined') {
                this.setState({ isActive: false });
                resolve();
                return;
            }

            var data = JSON.parse(list.result);
            this.setState({ listComplete: data }, async () => {
                await this.loadExpenseAccountCode();
                await this.loadPayUnit(true);
                await this.loadCorporateCreditCard();

                if (this.state.abcUsage || this.state.companyPayProject || this.state.linkProjectPActivity) {
                    await this.loadProjects();
                } else if (this.state.companyPayActivity && !this.state.linkProjectPActivity) {
                    await this.loadActivities();
                } else if (this.taskUsage) {
                    this.loadTask();
                }

                await this.loadDepartments();
                await this.loadWorksites();
                await this.loadProvinces();
                await this.loadWorkPlaces();
                await this.loadServiceProviders();

                this.enableUnitTypeCombo();
                this.setState({ isActive: false });
                resolve();
            });
        })
    }

    loadExpenseAccountCode = async () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.expenseAccountCodes;

            this.setState({ expenseAccountCodes: sortExpenseAccountCodesByCode(list) }, () => {
                if (this.state.expenseType != '') {
                    const objExpense = list.filter(item => item.accountExpenseCode == this.state.expenseType)[0];
                    // Load expense description
                    this.setState({
                        expenseTypeDescription: IsEnglish() ? objExpense.englishDescription : objExpense.frenchDescription,
                        maxQuantityUnit: objExpense.quantityMax,
                        payUnitMax: objExpense.payUnitMax,
                        payUnitDef: objExpense.payUnit,
                        isMandatoryLocation: objExpense.isMandatoryLocation,
                        isMandatoryFile: objExpense.isMandatoryFile,
                        nonTaxableTip: objExpense.nonTaxableTip
                    });
                }
                resolve();
            });
        })
    }

    loadPayUnit = async (isFirstLoad = false) => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.payUnits.filter(item => item.expenseAccountCode == this.state.expenseType);

            this.setState({ payUnits: sortPayUnitsByCode(list) }, () => {
                if (this.state.payUnits.length >= 1) {
                    let payUnit = this.state.expenseAccountPunchId > 0 && isFirstLoad ? list.filter(item => item.unitPayCode == this.state.unitType)[0] : this.state.payUnits[0];

                    // Check if we have a unit type max
                    if (this.state.payUnitMax !== null) {
                        payUnit = this.getPayUnit(this.state.payUnitMax);
                    }

                    this.changeUnitType(payUnit, isFirstLoad);
                }
                resolve();
            });
        })
    }

    loadCorporateCreditCard = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.creditCards;

            let element = {};
            element.corporateCardNumber = "";
            element.creditCardType = "";
            element.employeeCreditCardId = 0;
            element.creditCardType = IsEnglish() ? "REF" : "REM";
            element.englishDescription = "Refundable"
            element.frenchDescription = "Remboursable";
            list.push(element);

            this.setState({ corporateCreditCards: sortCorporateCreditCardsByCode(list) });
            resolve();
        })
    }

    loadProjects = () => {
        return new Promise((resolve) => {
            if (!this.state.abcUsage && !this.state.companyPayProject) {
                this.setState({ project: '', projectPay: '' });
                resolve();
                return;
            }

            const list = this.state.companyPayProject ? this.state.listComplete.projectsP : this.state.listComplete.projects;

            let defaultProject = this.state.companyPayProject ? this.state.projectPay : this.state.project;

            if (defaultProject === null || defaultProject === '') {
                defaultProject = this.state.companyPayProject ? this.state.projectPDefault : this.state.projectDefault;
            }

            // This is to avoid setting a project value in the save if no match project is found on the list
            const isMatch = list.filter(item => item.project === defaultProject);

            if (isMatch.length <= 0) {
                defaultProject = '';
            }

            this.setState(
                {
                    projects: sortProjectByCode(list),
                    project: this.state.companyPayProject ? '' : defaultProject,
                    projectPay: this.state.companyPayProject ? defaultProject : ''
                }, () => {
                    this.loadActivities();
                    resolve();
                });
        });
    }

    loadActivities = () => {
        return new Promise((resolve) => {
            if (!this.state.abcUsage && !this.state.companyPayActivity) {
                this.setState({ activity: '', activityPay: '' });
                resolve();
                return;
            }

            let list = this.state.listComplete.activities;

            if (this.state.abcUsage || (this.state.companyPayProject && this.state.linkProjectPActivity)) {
                const project = this.state.companyPayProject ? this.state.projectPay : this.state.project;

                list = list.filter(item => item.project == project);
            }

            let defaultActivity = this.state.companyPayActivity ? this.state.activityPay : this.state.activity;

            if (defaultActivity === null || defaultActivity === '') {
                defaultActivity = this.state.companyPayActivity ? this.state.activityPDefault : this.state.activityDefault;
            }

            // This is to avoid setting an activity value in the save if no match activity is found on the list
            const isMatch = list.filter(item => item.activity == defaultActivity);

            if (isMatch.length <= 0) {
                defaultActivity = '';
            }

            this.setState(
                {
                    activities: sortActivityByCode(list),
                    activity: this.state.companyPayActivity ? '' : defaultActivity.toString(),
                    activityPay: this.state.companyPayActivity ? defaultActivity : ''
                }, () => {
                    this.loadTask();
                    resolve();
                });

        });
    }

    loadTask = () => {
        return new Promise((resolve) => {
            if (!this.state.taskUsage && !this.state.linkProjectPActivity) {
                this.setState({ taskCode: '' });
                resolve();
                return;
            }

            let list = this.state.listComplete.tasks;
            let taskCodeDefault = this.state.taskCode;

            if (this.state.linkProjectPActivity) {

                list = list.filter(item => item.projectCode == this.state.projectPay && item.activityCode == this.state.activityPay);
            }

            const isMatch = list.filter(item => item.taskCode == taskCodeDefault);

            if (isMatch.length <= 0) {
                taskCodeDefault = '';
            }

            this.setState(
                {
                    taskCodes: sortTaskByCode(list),
                    taskCode: taskCodeDefault,
                    taskCodeDefault: taskCodeDefault
                }, () => {
                    resolve();
                });

        });
    }

    loadDepartments = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.departments;

            let defaultDepartment = this.state.department;

            if (defaultDepartment === null) {
                defaultDepartment = list[0].departmentCode;
            }
            this.setState({ departments: sortDepartmentByCode(list) }, () => {
                this.setState({ department: defaultDepartment });
            });
            resolve();
        });
    }

    loadWorksites = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.worksites;
            let worksiteDefault = this.state.worksite;

            if (this.state.expenseAccountPunchId === 0 && !worksiteDefault && list.length > 0) {
                worksiteDefault = list[0].worksite;
            }

            this.setState({ worksites: sortWorksiteByCode(list) }, () => {
                this.setState({ worksite: worksiteDefault, worksiteDefault: worksiteDefault });
            });
            resolve();
        });
    }

    loadProvinces = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.provinces;
            const defaultProvince = storage.getTaxationProvince();

            this.setState({ provinces: sortProvince(list) }, () => {
                if (this.state.expenseAccountPunchId <= 0) {
                    this.setState({ province: defaultProvince });
                }
            });
            resolve();
        })
    }

    loadWorkPlaces = () => {
        return new Promise((resolve) => {
            this.setState({ workPlaces: sortWorkPlaceByCode(this.state.listComplete.workPlaces) });
            resolve();
        });
    }

    loadServiceProviders = () => {
        return new Promise((resolve) => {
            if (this.state.useServiceProvider) {
                const expenseTypeId = this.state.listComplete.expenseAccountCodes.find(x => x.accountExpenseCode == this.state.expenseType)?.expenseAccountId;
                const list = this.state.listComplete.serviceProviders.filter(x => x.expenseAccountCodeId == expenseTypeId && this.state.workPlaceId && x.workPlaceId == this.state.workPlaceId);
                this.setState({ serviceProviders: sortServiceProvider(list) });
            }
            resolve();
        })
    }

    getNewState = (isChangeActiveState = true) => {

        const curExp = this.state.listComplete.expenseAccountCodes.filter(item => item.accountExpenseCode == this.state.expenseType)[0];
        const updStateObj = {};

        if (isChangeActiveState) {
            updStateObj.isActive = false;
        }

        if (!curExp || !curExp.isMandatoryLocation) {
            this.setState({ isMandatoryLocation: false });
        } else if (curExp) {
            const curServP = this.state.listComplete.serviceProviders.filter(x => x.expenseAccountCodeId == curExp.expenseAccountId && x.workPlaceId == this.state.workPlaceId)[0];
            if (!curServP) {
                updStateObj.serviceProviderId = null;
            }
        }

        return updStateObj;
    }

    changeUnitType = (unitType, isFirstLoadEdit = false) => {
        if (unitType != null) {
            let rate = 0;
            let disable = false;

            if (unitType.rate != null) {
                rate = unitType.rate;
            }

            if (rate != 0) {
                disable = true;
            }

            if (isFirstLoadEdit && this.state.expenseAccountPunchId > 0) {
                rate = this.state.unitRate;
            }

            this.setState({ unitType: unitType.unitPayCode, unitRate: rate, disableUnitRate: disable }, async () => {
                this.calculateTotal();
            });
        } else if (!isFirstLoadEdit) {
            this.setState({ unitType: '', unitRate: 0, disableUnitRate: false });
        }
    }

    onChangeProject = (event) => {
        const project = event.target.value;
        this.setState({ isActive: true, project: project }, () => {
            this.loadActivities().then(() => this.setState({ isActive: false }));
        });
    }

    onChangeExpenseType = (event) => {
        this.setState({ isActive: true, serviceProviderId: null, expenseType: event.target.value }, () => {
            let expenseAccountCode = this.state.expenseAccountCodes.find(exp => exp.accountExpenseCode === this.state.expenseType);
            let mandatoryUnitRateValue = this.state.expenseType == expenseTypeMR || this.state.expenseType == "";
            this.setState({
                isMandatoryComment: expenseAccountCode.mandatoryComment === 'O',
                isMandatoryUnitRate: mandatoryUnitRateValue,
                disableUnitRate: !mandatoryUnitRateValue,
                maxQuantityUnit: expenseAccountCode.quantityMax,
                payUnitMax: expenseAccountCode.payUnitMax,
                payUnitDef: expenseAccountCode.payUnit,
                hasNonRefundableSubCode: expenseAccountCode.nonRefundableSubCode != null,
                isMandatoryLocation: expenseAccountCode.isMandatoryLocation,
                isMandatoryFile: expenseAccountCode.isMandatoryFile,
                nonTaxableTip: expenseAccountCode.nonTaxableTip
            }, () => {
                this.enableUnitTypeCombo();

                this.loadPayUnit(false).then(() => {
                    this.setState({ isActive: false }, () => {
                        this.calculateTotal();
                        this.loadServiceProviders();
                    })
                });

                this.handleNonTaxableTip();
            });
        });
    }

    handleNonTaxableTip = () => {
        if (!this.state.nonTaxableTip) {
            this.setState({ tipAmount: 0 })
        }
    }

    setRateByUnitType = (unitPayCode) => {
        let unitType;

        for (var i = 0; i < this.state.payUnits.length; i++) {
            if (this.state.payUnits[i].unitPayCode === unitPayCode) {
                unitType = this.state.payUnits[i]
                break;
            }
        }
        this.changeUnitType(unitType);
    }

    onChangeUnitType = (event) => {
        this.setRateByUnitType(event.target.value);
    }

    loadParamDefault = () => {
        return new Promise(resolve => {
            paramDefault().then((result) => {
                if (typeof result === 'undefined') {
                    return;
                }
                const param = JSON.parse(result.param);
                this.setState({
                    // We will use this default params to clear the page
                    projectDefault: param.projectDef,
                    projectPDefault: param.projectPDef,
                    activityDefault: param.activityDef,
                    activityPDefault: param.activityPDef,
                    departmentDefault: param.departmentDef,
                    taskCodeDefault: param.taskPDef,

                    project: param.projectDef,
                    projectP: param.projectPDef,
                    activity: param.activityDef,
                    activityP: param.activityPDef,
                    department: param.departmentDef,
                    taskCode: param.taskPDef
                }, () => {
                    resolve();
                });
            });
        });
    }

    showMessageError = (msg) => {
        this.alert.current.showMessageError(msg);
    }

    onChangeActivity = (event) => {
        this.setState({ activity: event.target.value });
    }

    onChangeProjectPay = (event) => {
        this.setState(
            {
                isActive: true,
                projectPay: event.target.value
            }, async () => {
                await this.loadActivities();
                this.setState({ isActive: false });
            });
    }

    onChangeActivityPay = (event) => {
        this.setState(
            {
                activityPay: event.target.value
            }, async () => {
                if (this.state.taskUsage && this.state.linkProjectPActivity) {
                    this.loadTask();
                }
            });
    }

    onChangeTaskCode = (event) => {
        this.setState({ taskCode: event.target.value });
    }

    onChangeDepartment = (event) => {
        this.setState({ department: event.target.value }, async () => {
            await this.loadDropDowns();
        });
    }

    onChangeWorksite = (event) => {
        this.setState({ worksite: event.target.value });
    }

    onChangeProvince = (event) => {
        this.setState({ province: event.target.value });
    }

    onChangeComment = (event) => {
        this.setState({ comment: event.target.value });
    }

    handleOpenConfirm = () => {
        this.setState({ openConfirm: true });
    }

    handleCloseConfirm = () => {
        this.setState({ openConfirm: false });
    }

    handleOpenConfirmDeleteFile = (event, id) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ openConfirmDeleteFile: true, deleteFileId: id });
    }

    handleCloseConfirmDeleteFile = () => {
        this.setState({ openConfirmDeleteFile: false, deleteFileId: 0 });
    }

    onDateChange = (event) => {
        this.setState({ selectedDate: event.target.value });
    }

    onDateBlur = (event) => {
        this.setState({ isActive: true }, async () => {
            await this.loadDropDowns();
            const newState = this.getNewState(false);
            this.setState(newState, () => {
                this.setRateByUnitType(this.state.unitType);
                this.setState({ isActive: false });
            });
        });
    }

    onQuantityChange = (event) => {
        this.setState({ quantity: event.target.value }, () => {
            this.manageMaxQuantity();
        });
    }

    onUnitRateChange = (event) => {
        this.setState({ unitRate: event.target.value }, () => {
            this.calculateTotal();
        });
    }

    onTipAmountChange = (event) => {
        this.setState({ tipAmount: event.target.value }, () => {
            this.calculateTotal();
        });
    }

    onChangePaymentType = (event) => {
        this.setState({ paymentType: event.target.value });
    }

    calculateTotal = () => {
        const qty = toDecimal(this.state.quantity);
        const unitRate = toDecimal(this.state.unitRate);

        this.setState({ total: qty * unitRate });
    };

    enableUnitTypeCombo = () => {
        this.setState({
            hasPayUnitMax: this.state.payUnitMax !== null
        });
    }

    manageMaxQuantity = () => {
        return new Promise(async (resolve) => {
            if (this.state.payUnitMax !== null) {
                const quantity = this.state.quantity;

                await this.saveOriginalPayUnitQuantity();

                if (this.state.payUnitMax !== null && toDecimal(quantity) <= this.state.maxQuantityUnit) {
                    const payUnit = this.getPayUnit(this.state.payUnitMax);

                    this.setState({ quantity: 1 }, () => {
                        this.changeUnitType(payUnit, false);
                    });
                } else if (this.state.payUnitMax !== null && toDecimal(quantity) > this.state.maxQuantityUnit) {
                    const payUnit = this.getPayUnit(this.state.payUnitDef);

                    this.resetOriginalPayUnitQuantity();
                    this.changeUnitType(payUnit, false);
                }
            } else {
                this.calculateTotal();
            }
        })
    }

    saveOriginalPayUnitQuantity = () => {
        return new Promise((resolve) => {
            this.setState({
                originalQuantityUnit: this.state.quantity,
                originalPayUnit: this.state.payUnitDef
            }, () => {
                resolve();
            })
        })
    }

    resetOriginalPayUnitQuantity = () => {
        this.setState({
            originalQuantityUnit: 0,
            originalPayUnit: null
        })
    }

    getPayUnit = (payUnit) => {
        return this.state.listComplete.payUnits.filter(item => item.expenseAccountCode == this.state.expenseType && item.unitPayCode == payUnit)[0];
    }

    manageCommentPayUnit = () => {
        return new Promise(resolve => {
            const description = this.state.comment;

            const existsOriginalPayUnit = (this.existsOriginalPayUnit());

            if (this.state.originalPayUnit != null || (this.state.payUnitMax != null && this.state.quantity <= this.state.maxQuantityUnit)) {
                // if description already have the original pay unit / quantity, so we replace it
                if (description.length > 0) {
                    this.setState({ comment: this.removeDescriptionBreakLine(this.replaceOriginalPayUnit(description)) })
                }
            } else if (existsOriginalPayUnit) {
                // If the user edit the expense account and put a quantity more than the max again, so we can delete the history comment
                this.setState({ comment: this.deleteOriginalPayUnit(description) })
            }

            resolve();
        });
    }

    existsOriginalPayUnit = () => {
        const comment = this.state.comment;

        if (comment != null) {
            return comment.includes('[') && comment.includes(']');
        }

        return null;
    }

    replaceOriginalPayUnit = (description) => {
        const startIndex = description.indexOf('[');
        const endIndex = description.indexOf(']');

        const savedOriginalPayUnitComment = description.substring(startIndex + 1, endIndex)
        const displayComment = toDecimal(this.state.originalQuantityUnit) > 0 ? `[${toDisplayDecimal(toDecimal(this.state.originalQuantityUnit))} ${this.state.payUnitDef}]` : `[${savedOriginalPayUnitComment}]`;

        // Get all the description except the original pay unit
        let descriptionWithoutPayUnit = this.removeDescriptionBreakLine(description.substring(0, startIndex)) + this.removeDescriptionBreakLine(description.substring(endIndex + 1));

        return descriptionWithoutPayUnit + (descriptionWithoutPayUnit.substring(descriptionWithoutPayUnit.length - 1) !== '\n' ? `\n` : ``) + displayComment;
    }

    deleteOriginalPayUnit = (description) => {
        const startIndex = description.indexOf('[');
        const endIndex = description.indexOf(']');

        // Get all the description except the original pay unit
        const descriptionWithoutPayUnit = this.removeDescriptionBreakLine(description.substring(0, startIndex)) + this.removeDescriptionBreakLine(description.substring(endIndex + 1));

        return descriptionWithoutPayUnit;
    }

    removeDescriptionBreakLine = (description) => {
        // Remove first break line if exists

        if (description.substring(0, 1) === '\n') {
            return description.substring(1);
        }

        return description;
    }


    handleSaveClick = () => {
        this.setState({ isPostCompleted: false });

        // if the flag isCreditCardSupport = false, so the payment type = Refundable
        if (!this.state.isCreditCardSupport || !this.state.hasNonRefundableSubCode) {
            this.setState({ paymentType: 0 });
        }

        this.validateForm().then(async () => {
            if (!this.state.errorForm) {

                await this.manageCommentPayUnit();

                addExpenseAccount(this.state.expenseAccountPunchId, this.state.selectedDate, this.state.expenseType, this.state.comment,
                    toDecimal(this.state.quantity), this.state.unitType, toDecimal(this.state.unitRate), this.state.paymentType,
                    this.state.project, this.state.activity, this.state.projectPay, this.state.activityPay,
                    this.state.department, this.state.province, this.state.worksite, this.state.serviceProviderId, this.state.workPlaceId, this.state.taskCode, toDecimal(this.state.tipAmount)).then((response) => {
                        if (response == undefined) {
                            this.setState(
                                {
                                    loading: false,
                                    isPostCompleted: true
                                }, () => {
                                    this.showMessageError(i18next.t('error:generic-error'));
                                });
                            return;
                        }

                        const isWarning = response.validation === statusExpense.STATUS_ERRORWARNING;

                        if (response.status === true && (response.validation === statusExpense.STATUS_ERRORBLOCKED ||
                            response.validation === statusExpense.STATUS_ERRORGENERAL)) {
                            this.setState(
                                {
                                    loading: false,
                                    isPostCompleted: true
                                }, () => {
                                    this.showMessageError(response.messageError.join('\n'));
                                });
                        } else if (response.status === true && (response.validation === statusExpense.STATUS_OK ||
                            response.validation === statusExpense.STATUS_ERRORWARNING)) {
                            // save files
                            const id = response.expenseAccountId;

                            response.messageError.unshift(i18next.t('expenseAccount:message.success'))

                            if (id > 0 && this.state.files_upload.length > 0) {
                                let params = [];

                                const listFiles = this.state.files_upload.filter(item => document.querySelector(`#filename_${item.uid}`) != null);

                                listFiles.forEach(item => {
                                    const obj = {
                                        expenseAccountId: id,
                                        fileName: document.querySelector(`#filename_${item.uid}`).value,
                                        descriptionFile: document.querySelector(`#description_${item.uid}`).value,
                                        documentBase64: item.base64,
                                        documentType: item.documentType.replace('.', '').toUpperCase()
                                    }

                                    params.push(obj);
                                });

                                addDocument(params).then((result) => {
                                    if (result) {
                                        this.executeSuccessOperation(response.messageError.join('\n'), isWarning);
                                    }
                                })
                            }
                            else {
                                this.executeSuccessOperation(response.messageError.join('\n'), isWarning);
                            }
                        }
                        else {
                            this.alert.current.showMessageError(i18next.t('error:generic-error'));
                            this.setState({ loading: false, isPostCompleted: true });
                        }
                    });
            }
            else {
                this.setState({ isPostCompleted: true });
            }
        });
    }

    executeSuccessOperation = async (message, isWarning) => {
        if (this.state.expenseAccountPunchId > 0) {
            this.handleCloseEdit(message);
        }
        else {
            if (isWarning) {
                this.alert.current.showMessageWarning(message);
            } else {
                this.alert.current.showMessageSuccess(message);
            }

            this.setState({ loading: false });
            await this.resetExpenseAccount();
            this.setState({ isActive: false });
        }

        this.setState({ isPostCompleted: true });
    }

    validateForm = () => {
        return new Promise((resolve) => {
            let message = '';
            let error = false;

            if (this.state.selectedDate === null) {
                message = i18next.t('expenseAccount:message.selectedDate-form');
                error = true;
            } else if (this.state.expenseType === '') {
                message = i18next.t('expenseAccount:message.expenseType-form');
                error = true;
            } else if (this.state.unitType === '') {
                message = i18next.t('expenseAccount:message.unitType-form');
                error = true;
            } else if (!this.state.quantity || this.state.quantity == 0) {
                message = i18next.t('expenseAccount:message.quantity-form');
                error = true;
            } else if ((!this.state.unitRate || this.state.unitRate == 0)
                && (!this.state.isMandatoryLocation
                    || this.state.workPlaceId === 0 || this.state.workPlaceId === null || this.state.workPlaceId === ''
                    || this.state.serviceProviderId === 0 || this.state.serviceProviderId === null || this.state.serviceProviderId === '')) {
                message = i18next.t('expenseAccount:message.unitRate-form');
                error = true;
            } else if (this.state.isDisplayExpenseAccountClassif && ((this.state.abcUsage && (this.state.project === '' || this.state.project === null))
                || (this.state.companyPayProject && (this.state.projectPay === '' || this.state.projectPay === null)))) {
                message = i18next.t('expenseAccount:message.project-form');
                error = true;
            } else if (this.state.isDisplayExpenseAccountClassif && ((this.state.abcUsage && (this.state.activity === '' || this.state.activity === null))
                || (this.state.companyPayActivity && (this.state.activityPay === '' || this.state.activityPay === null)))) {
                message = i18next.t('expenseAccount:message.activity-form');
                error = true;
            } else if (this.state.isDisplayExpenseAccountClassif && ((this.state.taskUsage && (this.state.taskCode === '' || this.state.taskCode === null))
                || (this.state.taskUsage && (this.state.taskCode === '' || this.state.taskCode === null)))) {
                message = i18next.t('expenseAccount:message.taskCode-form');
                error = true;
            } else if (this.state.isMandatoryLocation && this.state.workPlaces.length > 0 && this.state.workPlaceId == null) {
                message = i18next.t('expenseAccount:message.workPlace-form');
                error = true;
            } else if (this.state.isMandatoryLocation && this.state.serviceProviders.length > 0 && this.state.serviceProviderId == null) {
                message = i18next.t('expenseAccount:message.serviceProvider-form');
                error = true;
            } else if (this.state.isDisplayExpenseAccountClassif && !this.state.department) {
                message = i18next.t('expenseAccount:message.department-form');
                error = true;
            } else if (this.state.isDisplayExpenseAccountClassif && !this.state.worksite) {
                message = i18next.t('expenseAccount:message.worksite-form');
                error = true;
            } else if (this.state.province === '' || this.state.province == null) {
                message = i18next.t('expenseAccount:message.province-form');
                error = true;
            } else if ((this.state.expenseAccountPunchId == 0 && this.state.isMandatoryFile && this.state.files_upload.length <= 0)
                || (this.state.expenseAccountPunchId > 0 && this.state.isMandatoryFile && this.state.files_edit.length <= 0 && this.state.files_upload.length <= 0)) {
                message = i18next.t('expenseAccount:message.fileMandatory-form');
                error = true;
            } else if (this.state.files_upload.length > 0) {
                this.state.files_upload.forEach(item => {
                    const name = document.querySelector(`#filename_${item.uid}`);

                    // Workaround to update the state
                    if (name === null) {
                        this.setState({
                            remove_files_upload: [
                                ...this.state.remove_files_upload,
                                { uid: item.uid }
                            ]
                        })
                    }
                    else if (name.value.trim() === '') {
                        message = i18next.t('expenseAccount:message.filename-form');
                        error = true;
                    }
                });
            } else {
                let expenseAccountCodes = this.state.expenseAccountCodes;
                let expenseAccountCode = expenseAccountCodes.find(exp => exp.accountExpenseCode === this.state.expenseType)

                if (expenseAccountCode != null && (expenseAccountCode.mandatoryComment === 'O' && !this.state.comment != null && !this.state.comment.trim())) {
                    message = i18next.t('expenseAccount:message.mandatoryComment-form');
                    error = true;
                }
            }

            this.setState({ errorForm: error }, () => {
                if (this.state.errorForm) {
                    this.showMessageError(message);
                    this.handleFileUpload();
                }
                resolve();
            });
        })
    }

    handleFileUpload = () => {
        const fileUpload = {
            ...this.state.files_upload
        };

        this.state.remove_files_upload.forEach(item => {
            const index = Object.values(fileUpload).findIndex(file => file.uid == item.uid);

            this.state.files_upload.splice(index, 1);
        });

        this.setState({ remove_files_upload: [] });
    }

    handleCloseOption = (event) => {
        this.setState({ openOption: false });
    }

    onAdd = (event) => {
        const afterStateChange = () => {
            event.affectedFiles
                .filter(file => !file.validationErrors)
                .forEach(file => {
                    const reader = new FileReader();

                    reader.onloadend = (ev) => {
                        this.setState({
                            filePreviews: {
                                ...this.state.filePreviews,
                                [file.uid]: ev.target.result
                            },
                            files_upload: [
                                ...this.state.files_upload,
                                {
                                    uid: file.uid,
                                    base64: ev.target.result.split('base64,')[1],
                                    documentType: file.extension

                                }]
                        });
                    };

                    reader.readAsDataURL(file.getRawFile());
                });
        };

        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `File selected: ${event.affectedFiles[0].name}`
            ]
        }, afterStateChange);
    }

    onRemove = (event) => {
        const filePreviews = {
            ...this.state.filePreviews
        };

        event.affectedFiles.forEach(file => {
            delete filePreviews[file.uid];
        });

        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `File removed: ${event.affectedFiles[0].name}`
            ],
            filePreviews: filePreviews
        });
    }

    onProgress = (event) => {
        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `On Progress: ${event.affectedFiles[0].progress} %`
            ]
        });
    }

    onStatusChange = (event) => {
        const fileStatuses = [
            'UploadFailed',
            'Initial',
            'Selected',
            'Uploading',
            'Uploaded',
            'RemoveFailed',
            'Removing'
        ];

        const file = event.affectedFiles[0];

        this.setState({
            files: event.newState,
            events: [
                ...this.state.events,
                `File '${file.name}' status changed to: ${fileStatuses[file.status]}`
            ]
        });
    }

    resetExpenseAccount = async (event) => {
        return new Promise(resolve => {
            this.setState({
                isActive: true,
                selectedDate: new Date(),
                expenseType: '',
                unitType: '',
                quantity: 0,
                unitRate: 0,
                paymentType: -1,
                expenseAccountCodes: [],
                payUnits: [],
                disableUnitRate: false,
                corporateCreditCards: [],
                projects: [],
                project: this.state.projectDefault,
                activity: this.state.activityDefault,
                department: this.state.departmentDefault,
                taskCode: this.state.taskCodeDefault,
                taskCodes: [],
                worksite: Worksite() ?? this.state.worksiteDefault,
                activities: [],
                departments: [],
                worksites: [],
                provinces: [],
                province: '',
                comment: '',
                workPlaceId: null,
                language: GetLanguage(),
                files: [],
                events: [],
                filePreviews: {},
                files_upload: []
            }, async () => {
                await this.loadDropDowns();
                resolve();
            });
        });
    }

    handleConfirmButtonClick = () => {
        this.setState({ openConfirmReset: true });
    }

    handleResetForm = async () => {
        await this.resetExpenseAccount();
        this.setState({ openConfirmReset: false });
    }

    handleCloseConfirmReset = () => {
        this.setState({ openConfirmReset: false });
    }

    handleDeleteButtonClick = () => {
        this.setState({ isDeleteCompleted: false });

        deleteExpenseAccount(this.state.expenseAccountPunchId).then((response) => {
            if (response) {
                this.handleCloseEdit(i18next.t('expenseAccount:message.delete'));
                this.setState({ isDeleteCompleted: true });
            }
        });
    }

    handleDownload = () => {
        if (this.state.downloadFile == null) {
            return;
        }

        const file = this.state.downloadFile;

        const linkSource = `data:application/octet-stream;base64,${file.base64}`;
        download(linkSource, `${file.filename}.${file.type.toLowerCase()}`, `application/octet-stream`);
    }

    resizeForm(expenseId) {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            let header = document.querySelector('div[data-id=headerExpenseAccount]').offsetHeight;
            const offSet = 80;

            if (expenseId > 0) {
                header = 0;
            }
            const customHeight = height - header - titleBar - offSet;

            const element = document.querySelector('#divForm');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }

    handleRemoveFile(id) {
        // delete file
        if (id.length > 0) {
            deleteDocument(id).then((response) => {
                if (response) {
                    // reload document list
                    this.loadDocument(this.state.expenseAccountPunchId);

                    this.handleCloseConfirmDeleteFile();
                }
            });
        }
    }

    handleOpenDownload = (event) => {
        const dataset = event.currentTarget.dataset;

        this.setState(
            {
                anchorEl: event.currentTarget,
                downloadFile: {
                    filename: dataset.filename,
                    base64: dataset.base64,
                    type: dataset.type
                }
            }
        );
    };

    handleCloseDownload = () => {
        this.setState(
            {
                anchorEl: null,
                downloadFile: null
            }
        );
    };

    handleFocus = (event) => {
        // this should be good on desktop and android
        //event.target.select();

        // workaround to make it work in iOS
        event.target.setSelectionRange(0, event.target.value.length);
    }

    onChangeServiceProvider = (event) => {
        this.setState({ serviceProviderId: event.target.value });
    }

    onChangeWorkPlace = (event) => {
        this.setState({ serviceProviderId: null, workPlaceId: event.target.value }, () => {

            const list = this.state.listComplete.payUnits.filter(item => item.expenseAccountCode == this.state.expenseType);

            if (this.state.payUnits.length >= 1 && this.state.unitType != '') {
                let payUnit = list.filter(item => item.unitPayCode == this.state.unitType)[0];

                // Check if we have a unit type max
                if (this.state.payUnitMax !== null) {
                    payUnit = this.getPayUnit(this.state.payUnitMax);
                }

                this.changeUnitType(payUnit, false);
            }

            this.calculateTotal();
            this.loadServiceProviders();
        });
    }

    render() {
        const { t } = this.props;
        const { classes } = this.props;
        let _el;

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('expenseAccount:form.loading')}
            >
                <LocalizationProvider language={this.state.language}>
                    <IntlProvider locale={this.state.language}>
                        <React.Fragment>
                            <AppBar position="fixed" className={`${classes.appBar} ${this.state.isiOS && classes.appBarIOS}`}>
                                <Toolbar className={classes.total}>
                                    <Typography variant="h6">Total{i18next.t('common:labelSeparator')} {toDisplayDecimal(this.state.total, 2, true)}</Typography>
                                </Toolbar>
                            </AppBar>
                        </React.Fragment>
                        <div id="divForm" className={styles.divExpenseForm}>
                            <InputLabel className={styles.labelDate + " labelDatePicker required"} htmlFor="date">Date</InputLabel>
                            <FormControl className={classes.date} fullWidth ref={el => (_el = el)}>
                                <DatePicker
                                    className={styles.inputDate + ' required'}
                                    name="date"
                                    value={this.state.selectedDate}
                                    onChange={this.onDateChange}
                                    onBlur={this.onDateBlur}
                                    format="yyyy-MM-dd"
                                    disabled={!this.state.canModify}
                                    popup={props => <Popup {...props} appendTo={_el} />} />
                            </FormControl>
                            <FormControl>
                                <div className={styles.divFormSelect}>
                                    <InputLabel className={"required"}>{t('expenseAccount:form.expenseType')}</InputLabel>
                                    <Select
                                        id="expenseType"
                                        value={this.state.expenseType || ''}
                                        onChange={this.onChangeExpenseType}
                                        disabled={!this.state.canModify}
                                    >
                                        {this.state.expenseAccountCodes.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.accountExpenseCode}>{`${obj.accountExpenseCode} - ${IsEnglish() ? obj.englishDescription : obj.frenchDescription}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                            <FormControl>
                                <div className={styles.divFormSelect}>
                                    <InputLabel className={"required"}>{t('expenseAccount:form.unitType')}</InputLabel>
                                    <Select
                                        id="unitType"
                                        value={this.state.unitType || ''}
                                        onChange={this.onChangeUnitType}
                                        disabled={(!this.state.canModify || this.state.hasPayUnitMax)}
                                    >
                                        {this.state.payUnits.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.unitPayCode}>{`${obj.unitPayCode} - ${IsEnglish() ? obj.englishDescription : obj.frenchDescription}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                            <div className={styles.divFormNumeric}>
                                <NumericTextField
                                    name="quantity"
                                    label={t('expenseAccount:form.quantity')}
                                    handleBlur={this.onQuantityChange}
                                    value={this.state.quantity}
                                    onFocus={this.handleFocus}
                                    disabled={!this.state.canModify}
                                    className={'required'}
                                />
                            </div>
                            <div className={styles.divFormNumeric}>
                                <NumericTextField
                                    name="unitRate"
                                    label={t('expenseAccount:form.unitRate')}
                                    handleBlur={this.onUnitRateChange}
                                    value={this.state.unitRate}
                                    onFocus={this.handleFocus}
                                    disabled={this.state.disableUnitRate || !this.state.canModify}
                                    className={this.state.isMandatoryUnitRate ? 'required' : ''}
                                />
                            </div>
                            {this.state.nonTaxableTip &&
                                <div className={styles.divFormNumeric}>
                                    <NumericTextField
                                        name="tipAmount"
                                        label={t('expenseAccount:form.tipAmount')}
                                        handleBlur={this.onTipAmountChange}
                                        value={this.state.tipAmount}
                                        onFocus={this.handleFocus}
                                        disabled={!this.state.canModify}
                                    />
                                </div>
                            }
                            {this.state.isCreditCardSupport && this.state.hasNonRefundableSubCode && (
                                <FormControl>
                                    <div className={styles.divFormSelect}>
                                        <InputLabel>{t('expenseAccount:form.paymentType')}</InputLabel>
                                        <Select
                                            id="paymentType"
                                            onChange={this.onChangePaymentType}
                                            value={this.state.paymentType}
                                            disabled={!this.state.canModify}
                                        >
                                            {this.state.corporateCreditCards.map((obj, index) =>
                                                <MenuItem key={index} className={styles.selectItem} value={obj.employeeCreditCardId}>{`${obj.creditCardType} - ${IsEnglish() ? obj.englishDescription : obj.frenchDescription} ${obj.employeeAccountNbr != null ? `(${obj.employeeAccountNbr})` : ''}`}</MenuItem>
                                            )}
                                        </Select>
                                    </div>
                                </FormControl>)}

                            {this.state.isDisplayExpenseAccountClassif && this.state.abcUsage &&
                                (
                                    <FormControl>
                                        <div className={styles.divFormSelect}>
                                            <InputLabel className={"required"} id="label-project">{t('expenseAccount:form.project')}</InputLabel>
                                            <Select
                                                labelId="label-project"
                                                id="project"
                                                value={this.state.project || ''}
                                                onChange={this.onChangeProject}
                                                disabled={!this.state.canModify}
                                            >
                                                {this.state.projects.map((obj, index) =>
                                                    <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </FormControl>
                                )
                            }

                            {this.state.isDisplayExpenseAccountClassif && this.state.abcUsage &&
                                (
                                    <FormControl>
                                        <div className={styles.divFormSelect}>
                                            <InputLabel className={"required"} id="label-activity">{t('expenseAccount:form.activity')}</InputLabel>
                                            <Select
                                                labelId="label-activity"
                                                id="activity"
                                                value={this.state.activity || ''}
                                                onChange={this.onChangeActivity}
                                                disabled={!this.state.canModify}
                                            >
                                                {this.state.activities.map((obj, index) =>
                                                    <MenuItem key={index} className={styles.selectItem} value={obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </FormControl>
                                )
                            }

                            {this.state.isDisplayExpenseAccountClassif && this.state.companyPayProject &&
                                (
                                    <FormControl fullWidth>
                                        <div className={styles.divFormSelect}>
                                            <InputLabel className={"required"} id="label-project-pay">{i18next.t('expenseAccount:form.project')}</InputLabel>
                                            <Select
                                                labelId="label-project-pay"
                                                id="projectPay"
                                                value={this.state.projectPay || ''}
                                                onChange={this.onChangeProjectPay}
                                                disabled={!this.state.canModify}
                                            >
                                                {this.state.projects.map((obj, index) =>
                                                    <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </FormControl>
                                )
                            }

                            {this.state.isDisplayExpenseAccountClassif && this.state.companyPayActivity &&
                                (
                                    <FormControl fullWidth>
                                        <div className={styles.divFormSelect}>
                                            <InputLabel className={"required"} id="label-activity-pay">{i18next.t('expenseAccount:form.activity')}</InputLabel>
                                            <Select
                                                labelId="label-activity-pay"
                                                id="activityPay"
                                                value={this.state.activityPay || ''}
                                                onChange={this.onChangeActivityPay}
                                                disabled={!this.state.canModify}
                                            >
                                                {this.state.activities.map((obj, index) =>
                                                    <MenuItem key={index} className={styles.selectItem} value={obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </FormControl>
                                )
                            }

                            {this.state.isDisplayExpenseAccountClassif && this.state.taskUsage &&
                                (
                                    <FormControl fullWidth>
                                        <div className={styles.divFormSelect}>
                                            <InputLabel className={"required"} id="label-task-code">{i18next.t('expenseAccount:form.taskCode')}</InputLabel>
                                            <Select
                                                labelId="label-task-code"
                                                id="taskCode"
                                                value={this.state.taskCode || ''}
                                                onChange={this.onChangeTaskCode}
                                                disabled={!this.state.canModify}
                                            >
                                                {this.state.taskCodes.map((obj, index) =>
                                                    <MenuItem key={index} className={styles.selectItem} value={obj.taskCode}>{`${obj.taskCode} - ${IsEnglish() ? obj.taskEn : obj.taskFr}`}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </FormControl>
                                )
                            }

                            {this.state.isMandatoryLocation && this.state.workPlaces.length > 0 &&
                                <FormControl fullWidth>
                                    <div className={styles.divFormSelect}>
                                        <InputLabel className={"required"} id="label-workPlace">{i18next.t('expenseAccount:form.workPlace')}</InputLabel>
                                        <Select
                                            labelId="label-workPlace"
                                            id="workPlace"
                                            value={this.state.workPlaceId || ''}
                                            onChange={this.onChangeWorkPlace}
                                            disabled={!this.state.canModify}
                                        >
                                            {this.state.workPlaces.map((obj, index) =>
                                                <MenuItem key={index} className={styles.selectItem} value={obj.workplaceId}>{`${obj.workplaceCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                            )}
                                        </Select>
                                    </div>
                                </FormControl>
                            }

                            {this.state.useServiceProvider && this.state.isMandatoryLocation && this.state.serviceProviders.length > 0 &&
                                <FormControl fullWidth>
                                    <div className={styles.divFormSelect}>
                                        <InputLabel className={"required"} id="label-service-provider">{i18next.t('expenseAccount:form.serviceProvider')}</InputLabel>
                                        <Select
                                            labelId="label-service-provider"
                                            id="serviceProvider"
                                            value={this.state.serviceProviderId || ''}
                                            onChange={this.onChangeServiceProvider}
                                            disabled={!this.state.canModify}
                                        >
                                            {this.state.serviceProviders.map((obj, index) =>
                                                <MenuItem key={index} className={styles.selectItem} value={obj.serviceProviderID}>{`${obj.serviceProviderCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                            )}
                                        </Select>
                                    </div>
                                </FormControl>
                            }

                            {this.state.isDisplayExpenseAccountClassif &&
                                <FormControl>
                                    <div className={styles.divFormSelect}>
                                        <InputLabel className={"required"} id="label-department">{t('expenseAccount:form.department')}</InputLabel>
                                        <Select
                                            labelId="label-department"
                                            id="department"
                                            value={this.state.department || ''}
                                            onChange={this.onChangeDepartment}
                                            disabled={!this.state.canModify}
                                        >
                                            {this.state.departments.map((obj, index) =>
                                                <MenuItem key={index} className={styles.selectItem} value={obj.departmentCode}>{`${obj.departmentCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                            )}
                                        </Select>
                                    </div>
                                </FormControl>
                            }

                            {this.state.isDisplayExpenseAccountClassif &&
                                <FormControl>
                                    <div className={styles.divFormSelect}>
                                        <InputLabel className={this.state.disableWorksite ? "" : "required"} id="label-worksite">{t('expenseAccount:form.worksite')}</InputLabel>
                                        <Select
                                            labelId="label-worksite"
                                            id="worksite"
                                            value={this.state.worksite || ''}
                                            onChange={this.onChangeWorksite}
                                            disabled={this.state.disableWorksite || !this.state.canModify}
                                        >
                                            {this.state.worksites.map((obj, index) =>
                                                <MenuItem key={index} className={styles.selectItem} value={obj.worksite}>{`${obj.worksite} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                            )}
                                        </Select>
                                    </div>
                                </FormControl>
                            }

                            <FormControl>
                                <div className={styles.divFormSelect}>
                                    <InputLabel className={"required"}>{t('expenseAccount:form.province')}</InputLabel>
                                    <Select
                                        id="province"
                                        value={this.state.province || ''}
                                        onChange={this.onChangeProvince}
                                        disabled={!this.state.canModify}
                                    >
                                        {this.state.provinces.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.provinceCode}>{IsEnglish() ? obj.provinceNameE : obj.provinceNameF}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>

                            <FormControl fullWidth>
                                <TextField
                                    id="comments"
                                    label={t('expenseAccount:form.comments')}
                                    multiline
                                    minRows={4}
                                    className={styles.inputComments + (this.state.isMandatoryComment ? " required" : "")}
                                    value={this.state.comment || ''}
                                    onChange={this.onChangeComment}
                                    disabled={!this.state.canModify}
                                />
                            </FormControl>

                            {this.state.canModify &&
                                <FormControl>
                                    <FormLabel className={`${styles.filesLabel} ${this.state.isMandatoryFile ? 'required' : ''}`}>{t('expenseAccount:form.files')}</FormLabel>

                                    <Upload
                                        listItemUI={CustomListItemUI}
                                        batch={false}
                                        multiple={true}
                                        files={this.state.files}
                                        withCredentials={false}
                                        autoUpload={false}
                                        showActionButtons={false}
                                        onAdd={this.onAdd}
                                        onRemove={this.onRemove}
                                        onProgress={this.onProgress}
                                        onStatusChange={this.onStatusChange}
                                        restrictions={{
                                            maxFileSize: 20000000
                                        }}
                                    />
                                </FormControl>}

                            <FormControl>
                                <div className={styles.listExpense}>
                                    <List>
                                        {this.state.files_edit.map((obj, index) =>
                                            <React.Fragment key={index}>
                                                <ListItem key={index} onClick={this.handleOpenDownload} button data-filename={obj.filename} data-base64={obj.base64} data-type={obj.type}>
                                                    <ListItemText primary={i18next.t('expenseAccount:files.filename') + ': ' + obj.filename} secondary={
                                                        <React.Fragment>
                                                            <span className={styles.listSubtitle1}>
                                                                {`${i18next.t('expenseAccount:files.description')}${i18next.t('common:labelSeparator')} ${obj.description}`}
                                                            </span>

                                                            {this.state.canModify && <strong className={styles.deleteFileList}>
                                                                <button type="button" tabIndex="-1" onClick={(event) => this.handleOpenConfirmDeleteFile(event, obj.documentId)} className="k-button k-button-icon k-flat k-upload-action">
                                                                    <span aria-label={i18next.t('expenseAccount:files.remove')} title={i18next.t('expenseAccount:files.remove')} className="k-icon k-delete k-i-x" />
                                                                </button>
                                                            </strong>}
                                                        </React.Fragment>
                                                    } />
                                                </ListItem>
                                                <Divider />
                                            </React.Fragment>
                                        )}
                                    </List>
                                </div>
                            </FormControl>

                            <FormControl className={styles.divButtons}>
                                {this.state.canModify &&
                                    <Button
                                        loading={!this.state.isPostCompleted}
                                        className={styles.saveButton}
                                        onClick={this.handleSaveClick}
                                        variant="success"
                                    >
                                        {t('expenseAccount:button.save')}
                                    </Button>}

                                {this.state.expenseAccountPunchId > 0 && this.state.canModify &&
                                    <Button
                                        loading={!this.state.isDeleteCompleted}
                                        className={`${styles.deleteButton} ${classes.deleteBtn}`}
                                        onClick={this.handleOpenConfirm}
                                        variant="danger"
                                    >
                                        {t('expenseAccount:button.delete')}
                                    </Button>
                                }

                                {this.state.expenseAccountPunchId == 0 &&
                                    <Button
                                        className={`resetButton ${classes.resetBtn}`}
                                        onClick={this.handleConfirmButtonClick}
                                        variant="success"
                                    >
                                        {t('expenseAccount:button.reset')}
                                    </Button>
                                }
                            </FormControl>
                            <OptionExpenseAccount open={this.state.openOption} onClose={this.handleCloseOption} />

                            <Dialog
                                open={this.state.openConfirm}
                                onClose={this.handleCloseConfirm}
                                aria-labelledby="draggable-dialog-title"
                            >
                                <DialogTitle id="draggable-dialog-title">
                                    {i18next.t('expenseAccount:form.warning')}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        {format(i18next.t('expenseAccount:message.confirmDelete'), formatDate(this.state.selectedDate, 'date'), this.state.expenseTypeDescription, this.state.total != undefined ? toDisplayDecimal(this.state.total, 2, true) : 0)}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseConfirm} color="primary" className={styles.buttonYesNo} variant="success">
                                        {i18next.t('expenseAccount:form.no')}
                                    </Button>
                                    <Button autoFocus onClick={this.handleDeleteButtonClick} color="primary" className={styles.buttonYesNo} variant="success">
                                        {i18next.t('expenseAccount:form.yes')}
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={this.state.openConfirmDeleteFile}
                                onClose={this.handleCloseConfirmDeletefile}
                                aria-labelledby="draggable-dialog-title"
                            >
                                <DialogTitle id="draggable-dialog-title">
                                    {i18next.t('expenseAccount:form.warning')}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        {i18next.t('expenseAccount:message.confirmDeleteFile')}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseConfirmDeleteFile} color="primary" className={styles.buttonYesNo} variant="success">
                                        {i18next.t('expenseAccount:form.no')}
                                    </Button>
                                    <Button autoFocus onClick={() => this.handleRemoveFile(this.state.deleteFileId)} color="primary" className={styles.buttonYesNo} variant="success">
                                        {i18next.t('expenseAccount:form.yes')}
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={this.state.openConfirmReset}
                                onClose={this.handleCloseConfirmReset}
                                aria-labelledby="draggable-dialog-title"
                            >
                                <DialogTitle id="draggable-dialog-title">
                                    {i18next.t('expenseAccount:form.warning')}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        {i18next.t('expenseAccount:form.confirmMessage')}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseConfirmReset} color="primary" className={styles.buttonYesNo} variant="success">
                                        {i18next.t('expenseAccount:form.no')}
                                    </Button>
                                    <Button autoFocus onClick={this.handleResetForm} color="primary" className={styles.buttonYesNo} variant="success">
                                        {i18next.t('expenseAccount:form.yes')}
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.anchorEl}
                                keepMounted
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleCloseDownload}
                            >
                                <MenuItem onClick={this.handleDownload}>{i18next.t('expenseAccount:form.download')}</MenuItem>
                            </Menu>
                            <AlertAlgo ref={this.alert} />
                        </div>
                    </IntlProvider>
                </LocalizationProvider>
            </LoadingOverlay>)
    }
}

registerForIntl(ExpenseAccountForm);

export default withNamespaces(['expenseAccount', 'error', 'common'], { wait: true })(withStyles(stylesMat)(ExpenseAccountForm));